import React, { useContext, useEffect } from "react";

import { useSearch } from "../../../../hooks/useSearch";
import {
  BrowserContext,
  BrowserContextProvider,
  SearchContext,
} from "../../../../providers";
import ItemPickerLayout from "../item-picker/ItemPickerLayout";
import ItemPickerMainLayout from "../item-picker/ItemPickerMainLayout";

import PassagePickerFilters from "./PassagePickerFilters";
import PassagePickerPreview from "./PassagePickerPreview";

const PassagePickerInner = (props: {
  onSelect: (itemIds: string[]) => void;
}) => {
  const [browserState] = useContext(BrowserContext);

  const { onSelect } = props;
  useEffect(() => {
    console.log("hello");
    onSelect(browserState.selected.map((item) => item.id));
    // onSelect will trigger infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [browserState.selected]);

  return (
    <ItemPickerLayout
      main={<ItemPickerMainLayout filters={<PassagePickerFilters />} />}
      preview={<PassagePickerPreview />}
    />
  );
};

const PassagePicker = (props: { onSelect: (assetIds: string[]) => void }) => {
  const search = useSearch({
    queryKey: "passage-picker-results",
    baseFilter: {
      sk: {
        eq: "resource#v0",
      },
      type: {
        eq: "PASSAGE",
      },
    },
  });

  return (
    <SearchContext.Provider value={search}>
      <BrowserContextProvider>
        <PassagePickerInner {...props} />
      </BrowserContextProvider>
    </SearchContext.Provider>
  );
};

export default PassagePicker;
